import { Box } from '@mui/material'
import { useEffect, useState } from 'react'
import { getMainPage } from '../../services/ContentServices'
import { ModuleComponent, ModuleComponents } from '../../types/ContentStructure'
import ComponentType from '../component_type/ComponentType'

const MainPage = () => {
    const [mainPage, setMainPage] = useState<ModuleComponents>()
    useEffect(() => {
        const fetchData = async () => {
            const response = await getMainPage();
            setMainPage(response.data);
        }
        fetchData();
    }, [])

    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            overflow: 'hidden',
        }}>
            {mainPage && mainPage.components.length > 0 &&
                mainPage.components.map((item: ModuleComponent, idx: number) => {
                    return <ComponentType key={idx} component={item.component} />
                })
            }
        </Box>
    )
}

export default MainPage
